<div class="manual-row-sort">
  <mat-radio-group class="is-enabled-radio-group" [(ngModel)]="isManualRowSortEnabled">
    <mat-radio-button [value]="false" class="redRadio"> <span class="radio-lable">{{ 'dashboard:Value in a column' | i18next }}</span></mat-radio-button>
    <mat-radio-button [value]="true" class="redRadio"> <span class="radio-lable">{{ 'dashboard:Manual sort order' | i18next }}</span></mat-radio-button>
  </mat-radio-group>
</div>
<div *ngIf="isManualRowSortEnabled" class="list-wrapper">
  <!--<div class="manual-sort-order-header"> {{ 'dashboard:Row order' | i18next }}</div>-->
  <div cdkDropList (cdkDropListDropped)="drop($event)"  class="cdkDropList">
    <div *ngFor="let item of items" cdkDrag class="row-list-item">
      <div class="drag-placeholder" *cdkDragPlaceholder></div>
      <i class="fa fa-bars"></i>
      <div class="item-label">{{ item[bindLabel] }}</div>
    </div>
  </div>
</div>
